import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

Vue.prototype.$showLoading = () => {
    Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
    });
}

Vue.prototype.$hideLoading = () => {
    Toast.clear();
}